export default __webpack_public_path__ + "static/media/InterferenceFitsImg.05f91ded.jpg";